module.exports = __webpack_public_path__ + "img/QRCode.f862f76f.png";